import { useState } from "react";
import { Inbox, CheckCheck, Search, X, ArrowLeft, Users } from "lucide-react";
import { V } from "@/lib/vocab";

export function Toolbar({ box, onBox, counts, query, onQuery, scope, onScope, isPlatformView, canMarkAll, onMarkAll }) {
  const [confirm, setConfirm] = useState(false);
  const onSecondary = scope === "community";
  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="feedback-toolbar">
      <div className="inline-flex rounded-full border border-sand-200 bg-white p-1 shrink-0" data-testid="feedback-box-toggle">
        {[["new", "Inbox", Inbox, counts.new], ["done", "Done", CheckCheck, counts.done]].map(([k, l, Icon, n]) => (
          <button key={k} data-testid={`feedback-box-${k}`} onClick={() => onBox(k)} aria-pressed={box === k}
            className={`rounded-full px-4 py-1.5 text-sm font-bold transition-colors inline-flex items-center gap-1.5 ${
              box === k ? "bg-ink text-white" : "text-ink/60 hover:text-ink"}`}>
            <Icon className="h-3.5 w-3.5" /> {l}
            <span data-testid={`feedback-box-${k}-count`} className={`text-xs tabular-nums ${box === k ? "text-white/70" : "text-ink/40"}`}>{n ?? ""}</span>
          </button>
        ))}
      </div>

      <div className="relative flex-1 min-w-[200px] max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink/35 pointer-events-none" />
        <input data-testid="feedback-search" value={query} onChange={(e) => onQuery(e.target.value)} placeholder="Search feedback, names, numbers…"
          className="w-full rounded-full border border-sand-200 bg-white pl-9 pr-9 py-2 text-sm text-ink placeholder:text-ink/35 focus:outline-none focus:border-ink/40 transition-colors" />
        {query && (
          <button data-testid="feedback-search-clear" onClick={() => onQuery("")} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-ink/40 hover:text-ink transition-colors" aria-label="Clear search">
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>

      <div className="ml-auto flex items-center gap-2 flex-wrap">
        {canMarkAll && (confirm ? (
          <span className="inline-flex items-center gap-2 text-sm text-ink/80" data-testid="feedback-mark-all-confirm">
            Mark all {counts.new} done?
            <button data-testid="feedback-mark-all-yes" onClick={() => { setConfirm(false); onMarkAll(); }} className="rounded-full bg-emerald-600 text-white px-3 py-1.5 text-xs font-bold hover:bg-emerald-700 transition-colors">Yes</button>
            <button data-testid="feedback-mark-all-no" onClick={() => setConfirm(false)} className="rounded-full border border-sand-200 bg-white px-3 py-1.5 text-xs font-bold text-ink/70 hover:border-ink/40 transition-colors">No</button>
          </span>
        ) : (
          <button data-testid="feedback-mark-all" onClick={() => setConfirm(true)}
            className="inline-flex items-center gap-1.5 rounded-full border border-sand-200 bg-white px-3.5 py-2 text-xs font-bold text-ink/70 hover:border-ink/40 transition-colors">
            <CheckCheck className="h-3.5 w-3.5" /> Mark all done
          </button>
        ))}
        {/* Redline's console only — peek at what residents told each community. Managers never
            see AI feedback; that is Redline's to read, on Platform Feedback. */}
        {isPlatformView && (
          <button data-testid="feedback-scope-toggle" onClick={() => onScope(onSecondary ? "platform" : "community")}
            className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-xs font-bold border transition-colors ${
              onSecondary ? "bg-ink text-white border-ink hover:bg-ink-700" : "bg-white text-ink/70 border-sand-200 hover:border-ink/40"}`}>
            {onSecondary ? <><ArrowLeft className="h-3.5 w-3.5" /> Back to AI feedback</> : <><Users className="h-3.5 w-3.5" /> {V.one("org")} feedback <span className="text-ink/40 tabular-nums">{counts.community ?? ""}</span></>}
          </button>
        )}
      </div>
    </div>
  );
}
